export default __webpack_public_path__ + "static/Festl_Tour_Impressionen_2-ab79a40164a77a8e9df86cb8a94c91bc.jpg";